(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDialogController', CustomCaseTypeAttributeDialogController);

    CustomCaseTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customcasetypeattributevalues = CustomCaseTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customCaseTypeAttribute.customCaseTypeAttributeValues != null && vm.customCaseTypeAttribute.customCaseTypeAttributeValues.length != 0) {
			vm.items = vm.customCaseTypeAttribute.customCaseTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customCaseTypeAttribute.id !== null) {
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomCaseTypeAttribute.update(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomCaseTypeAttribute.save(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customCaseTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-case-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
